import inventoryStoreMutations from './inventoryStore/inventoryStoreMutations'
import inventoryStoreActions from './inventoryStore/inventoryStoreActions'
import getInventoryStoreDefaultState from './inventoryStore/inventoryStoreDefaultState'

let state = getInventoryStoreDefaultState()

export const inventoryStore = {
  namespaced: true,
  state,
  mutations: inventoryStoreMutations,
  actions: inventoryStoreActions,
  getters: {
    productsToReplenish: state => {
      return state.productInventoryList.filter(
        product => product.replenish === true
      )
    }
  }
}
